import { render } from "./Billing.vue?vue&type=template&id=c025eb08&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=c025eb08&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-c025eb08"

export default script